import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import NativeSelectInput from '../../../../components/shared/components/NativeSelectInput';
import BootstrapInput from '../../../shared/components/OutlinedInputBox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { RadioIcon, RadioFillIcon } from '../../../../style';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  root: {
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  title: {
    width: '100%'
  },
  duration: {
    width: '90%'
  },
  payoutContainer: {
    marginTop: '20px'
  },
  radio: {
    width: '15px'
  },
  select: {
    width: '100%',
    marginTop: '0px',
    marginBottom: '0px',
    '& > *': {
      maxWidth: 410,
      width: '100%'
    }
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  urlButton: {
    height: '50px',
    width: '100px',
    color: 'black'
  },
  urlButtonSelected: {
    color: 'white'
  },
  nobutton: {
    marginLeft: '30px'
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  },
  payoutContainer: {
    maxWidth: '442px'
  },
  toText: {
    display: 'inline-flex',
    marginTop: '12px',
    marginRight: '5px',
    marginLeft: '5px'
  }
});

class CreateDetails extends React.Component {
  constructor() {
    super();

    this.state = {
      submitAttempted: false,
      campaignTitleErrorText: '',
      campaignGoalsErrorText: '',
      payoutMinErrorText: '',
      payoutMaxErrorText: ''
    };
  }

  payoutMinHasError = () => {
    return (
      (this.props.campaignInfo.productAndCommission ||
        this.props.campaignInfo.commissionOnly) &&
      parseInt(this.props.campaignInfo.payoutMin) < 25
    );
  };

  payoutMaxHasError = () => {
    return (
      (this.props.campaignInfo.productAndCommission ||
        this.props.campaignInfo.commissionOnly) &&
      parseInt(this.props.campaignInfo.payoutMax) <
        parseInt(this.props.campaignInfo.payoutMin)
    );
  };

  handleNextClick() {
    this.setState({
      // submitAttempted: true,
      campaignTitleErrorText: this.props.campaignInfo.name
        ? ''
        : 'campaign title is required',
      campaignGoalsErrorText: this.props.campaignInfo.goals
        ? ''
        : 'campaign goal is required',
      payoutMinErrorText: this.payoutMinHasError()
        ? 'payout must be a minimum of $25'
        : '',
      payoutMaxErrorText: this.payoutMaxHasError()
        ? 'must be greater than the payout miniumum'
        : ''
    });

    if (
      !this.props.campaignInfo.name ||
      !this.props.campaignInfo.goals ||
      this.payoutMinHasError() ||
      this.payoutMaxHasError()
    ) {
      this.setState({
        submitAttempted: true
      });
    } else {
      this.setState({
        submitAttempted: true
      });

      if (this.props.campaignInfo.productOnly) {
        this.props.clearPayouts();
      }
      this.props.nextButtonClick();
    }
  }

  render() {
    const {
      classes,
      campaignInfo,
      changeHandler,
      prodCommissionHandler,
      isPrivateCampaignHandler,
      nextButtonClick,
      backButtonClick
    } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Grid
            container
            direction="row"
            align="left"
            justify="center"
            spacing={4}
          >
            <Grid item xs={12}>
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Campaign Title
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={'Enter a descriptive title for your campaign.'}
                  />
                </div>
                <TextField
                  id="name"
                  name="name"
                  variant="outlined"
                  className={classes.title}
                  value={campaignInfo.name}
                  onChange={changeHandler}
                  error={
                    this.state.submitAttempted &&
                    this.state.campaignTitleErrorText
                      ? true
                      : false
                  }
                  helperText={
                    this.state.submitAttempted
                      ? this.state.campaignTitleErrorText
                      : ''
                  }
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.rowSection}>
                <Typography gutterBottom display="inline">
                  Campaign Goals
                </Typography>
                <HpTooltip
                  styling={{
                    marginLeft: '5px',
                    marginBottom: '2px'
                  }}
                  message={
                    "Enter goals for your campaign. Views per post you'd like to see, channel size, etc. These are not requirements but should help align the best campaign creators to your campaign."
                  }
                />
                <TextField
                  id="goals"
                  name="goals"
                  variant="outlined"
                  multiline
                  className={classes.title}
                  value={campaignInfo.goals}
                  onChange={changeHandler}
                  error={
                    this.state.submitAttempted &&
                    this.state.campaignGoalsErrorText
                      ? true
                      : false
                  }
                  helperText={
                    this.state.submitAttempted
                      ? this.state.campaignGoalsErrorText
                      : ''
                  }
                />
              </div>
            </Grid>
            <Grid item container direction="row" sm={12}>
              <Grid
                item
                container
                direction="column"
                alignItems="left"
                xs={12}
                sm={4}
              >
                <Grid item>
                  <div className={classes.rowSection}>
                    <RadioGroup
                      aria-label="payout"
                      name="payout"
                      onChange={prodCommissionHandler}
                    >
                      <div>
                        <FormControlLabel
                          value="productAndCommission"
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon />}
                              checkedIcon={<RadioFillIcon />}
                              checked={campaignInfo.productAndCommission}
                            />
                          }
                          label="Product + Payout"
                          labelPlacement="end"
                        />
                        <HpTooltip
                          styling={{
                            marginLeft: '-10px',
                            marginBottom: '8px'
                          }}
                          message={
                            'The content creator will receieve the product and a cash payout.'
                          }
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          value="commissionOnly"
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon />}
                              checkedIcon={<RadioFillIcon />}
                            />
                          }
                          label="Payout Only"
                          labelPlacement="end"
                        />
                        <HpTooltip
                          styling={{
                            marginLeft: '-10px',
                            marginBottom: '8px'
                          }}
                          message={
                            'The content creator will only receieve a cash payout.'
                          }
                        />
                      </div>
                      <div>
                        <FormControlLabel
                          value="productOnly"
                          control={
                            <Radio
                              color="primary"
                              icon={<RadioIcon />}
                              checkedIcon={<RadioFillIcon />}
                            />
                          }
                          label="Product Only"
                          labelPlacement="end"
                        />
                        <HpTooltip
                          styling={{
                            marginLeft: '-10px',
                            marginBottom: '8px'
                          }}
                          message={
                            'The content creator will only recieve the product.'
                          }
                        />
                      </div>
                    </RadioGroup>
                  </div>
                </Grid>
              </Grid>
              <Grid item sm={8} align="left">
                {!campaignInfo.productOnly && (
                  <React.Fragment>
                    <div>
                      <Typography gutterBottom align="left" display="inline">
                        Payout Range per Deal
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '2px'
                        }}
                        message={
                          'Enter the payout range you are willing to pay a content creator for completing this campaign.'
                        }
                      />
                    </div>
                    <TextField
                      id="payoutMin"
                      name="payoutMin"
                      variant="outlined"
                      className={classes.payout}
                      value={campaignInfo.payoutMin}
                      onChange={changeHandler}
                      type="number"
                      error={
                        this.state.submitAttempted &&
                        this.state.payoutMinErrorText
                          ? true
                          : false
                      }
                      helperText={
                        this.state.submitAttempted
                          ? this.state.payoutMinErrorText
                          : ''
                      }
                    />
                    <Typography className={classes.toText}> to </Typography>
                    <TextField
                      id="payoutMax"
                      name="payoutMax"
                      variant="outlined"
                      className={classes.payout}
                      value={campaignInfo.payoutMax}
                      onChange={changeHandler}
                      type="number"
                      error={
                        this.state.submitAttempted &&
                        this.state.payoutMaxErrorText
                          ? true
                          : false
                      }
                      helperText={
                        this.state.submitAttempted
                          ? this.state.payoutMaxErrorText
                          : ''
                      }
                    />
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div>
                <Typography gutterBottom align="left" display="inline">
                  Is this campaign Private?
                </Typography>
                <HpTooltip
                  styling={{
                    marginLeft: '5px',
                    marginBottom: '2px'
                  }}
                  message={`Only users you send a campaign link to will be able to view and apply to this campaign. 
                          Content creators will not be able to discover this campaign on their own.`}
                />
              </div>
              <Button
                id="isPrivateCampaign"
                name="isPrivateCampaign"
                variant="contained"
                color={campaignInfo.isPrivate && 'primary'}
                className={`
                        ${classes.urlButton}
                        ${campaignInfo.isPrivate && classes.urlButtonSelected}
                      `}
                onClick={() => isPrivateCampaignHandler(true)}
              >
                Yes
              </Button>
              <Button
                id="isNotPrivateCampaign"
                name="isNotPrivateCampaign"
                variant="contained"
                color={!campaignInfo.isPrivate && 'primary'}
                className={`
                        ${classes.urlButton}
                        ${!campaignInfo.isPrivate && classes.urlButtonSelected}
                        ${classes.nobutton}
                      `}
                onClick={() => isPrivateCampaignHandler(false)}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </div>
        <div className={classes.buttons}>
          <Button onClick={backButtonClick} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleNextClick.bind(this)}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

CreateDetails.PropTypes = {
  campaignInfo: PropTypes.object,
  changeHandler: PropTypes.func,
  prodCommissionHandler: PropTypes.func
};

export default withStyles(styles)(CreateDetails);



// WEBPACK FOOTER //
// ./src/components/company/campaign/components/CampaignDetails.js